import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { File } from '@/types';

const useGetMatterFiles = (caseId: string | null, matterId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<File[], Error>(
    [QueryEntity.Files, { caseId, matterId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/files/matter/${matterId}`, fetchConfigGET);
      const data = await response.json();
      return data.files;
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};

export default useGetMatterFiles;
